export default __webpack_public_path__ + "static/tek_img_08-95ef586da5e70e5853d11ea86d590258.webp";